module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=HM - Heard Island and McDonald Islands.d1fa36af.svg";